import { isNil } from 'lodash';

export const toAmountString = (val: number, currency?: string): string => {
	if (typeof val === 'string') return val;
	if (Number.isNaN(val)) {
		return '0.00';
	}

	if (currency?.includes('.')) {
		const fixed = val.toFixed(2);
		return currency ? `${fixed} ${currency}` : fixed;
	}

	const formatterCurrency = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: currency && currency !== 'tEUR' ? currency : 'EUR',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
	const formatterNoCurrency = new Intl.NumberFormat('en-US', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});

	let result = currency && currency !== 'tEUR' ? formatterCurrency.format(val) : formatterNoCurrency.format(val);
	let currencySign = formatterCurrency?.formatToParts(0)?.find((part) => part.type === 'currency')?.value || '';

	if (currency === 'tEUR') {
		currencySign = 'tEUR';
	}

	if (val < 0 && currency) {
		result = result.replace(currencySign, '');
		result = `${currencySign} ${result.trim()}`;
	}

	return result;
};

export const formatCents = (value: number): string => {
	const num = value / 100;
	return isNil(value) ? '' : toAmountString(num);
};

export const convertToEUR = (value: number | string, rate?: number, currency?: string): string => {
	const convertToNumber = !value ? 0 : typeof value === 'number' ? value : parseFloat(value?.replace(/,/g, ''));
	const calc = rate ? (convertToNumber / 100) * (rate / 1000000) : convertToNumber / 100;
	return rate === 0 ? `0 No AVG rate` : toAmountString(calc, currency);
};

export const convertToNumericEUR = (value: number, rate?: number): number => {
	const calc = rate ? (value / 100) * (rate / 1000000) : value / 100;
	return rate === 0 ? 0 : calc;
};

export const isValidFloat = (value: string): boolean => {
	const number = parseFloat(value);
	return !isNaN(number) && isFinite(number) && String(value).includes('.');
};
